import React, { useRef } from "react";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import SectionHeader from "./SectionHeader";
import SectionMain from "./SectionMain";

const SectionLayout = ({ sectionId, section, dashboardId }) => {
  const firstMountRef = useRef(true);

  return (
    <AccordionItem
      value={`item-${sectionId}`}
      className="px-2 border-none bg-zinc-800 rounded-md data-[state=true]:bg-red-400"
    >
      <AccordionTrigger className="p-2 hover:no-underline">
        <SectionHeader
          sectionId={sectionId}
          dashboardId={dashboardId}
          sectionLabel={section.label}
        />
      </AccordionTrigger>
      <AccordionContent>
        <SectionMain
          section={section}
          sectionId={sectionId}
          dashboardId={dashboardId}
          firstMountRef={firstMountRef}
        />
      </AccordionContent>
    </AccordionItem>
  );
};

export default SectionLayout;
